import React from "react";
import { BorrowingContent } from "../../content/borrowing/borrowingList";
import { Layout } from "../../layout/page";

export function Borrowing() {
  return (
    <Layout>
      <BorrowingContent />
    </Layout>
  );
}
